import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClassificationsTemplateModule} from './classifications-template/classifications-template.module';
import {FeaturesAndBenefitsModule} from './features-and-benefits/features-and-benefits.module';
import {HeroModule} from './hero/hero.module';
import {NavigationBarModule} from './navigation-bar/navigation-bar.module';
import {PlansAndPricingModule} from './plans-and-pricing/plans-and-pricing.module';

import {ProductSupportWidgetModule} from './product-support-widget/product-support-widget.module';
import {PublisherModule} from './publisher/publisher.module';
import {ResourcesModule} from './resources/resources.module';
import {ReviewModule} from './review/review.module';
import {TechnicalInformationModule} from './technical-information/technical-information.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ClassificationsTemplateModule,
    FeaturesAndBenefitsModule,
    HeroModule,
    NavigationBarModule,
    PlansAndPricingModule,
    ProductSupportWidgetModule,
    PublisherModule,
    ResourcesModule,
    ReviewModule,
    TechnicalInformationModule,
  ],
})
export class ProductDetailsModule {}
